/** SurfaceHeader — the shared domain header: mono kicker (domain accent), title,
 *  description, and an optional right-hand slot (lineage / policy toggles). */
import React from 'react'

interface SurfaceHeaderProps {
  kicker: string
  kickerColor?: string
  title: string
  desc?: string
  right?: React.ReactNode
}

export default function SurfaceHeader({ kicker, kickerColor = 'var(--brand)', title, desc, right }: SurfaceHeaderProps): React.JSX.Element {
  return (
    <div className="flex justify-between items-end gap-5 flex-wrap">
      <div>
        <div className="font-mono text-[10px] tracking-[.16em] uppercase mb-1.5" style={{ color: kickerColor }}>
          {kicker}
        </div>
        <h1 className="text-[26px] font-bold tracking-[-.02em] text-ink">{title}</h1>
        {desc && <p className="mt-1.5 text-[13.5px] text-mut max-w-[660px]">{desc}</p>}
      </div>
      {right}
    </div>
  )
}
